/**
 * Custom network logos live in `public/assets/networks/{slug}.svg`.
 * Add a slug here when a dedicated network asset exists; others fall back to token icons.
 */
export const NETWORK_ICON_PATHS: Record<string, string> = {
	base: "/assets/networks/base.svg",
	robinhood: "/assets/networks/robinhood.svg",
};

/** Token symbol fallback when no custom network SVG is registered. */
export const NETWORK_TOKEN_FALLBACK: Record<string, string> = {
	ethereum: "eth",
	polygon: "matic",
	arbitrum: "arb",
	optimism: "op",
	base: "base",
	unichain: "uni",
	robinhood: "eth",
};

export function normalizeNetworkSlug(network: string): string {
	return network.trim().toLowerCase();
}

export function getNetworkIconPath(network: string): string | null {
	const slug = normalizeNetworkSlug(network);
	return NETWORK_ICON_PATHS[slug] ?? null;
}

export function hasNetworkIcon(network: string): boolean {
	return getNetworkIconPath(network) !== null;
}

export function getNetworkTokenFallbackSymbol(network: string): string {
	const slug = normalizeNetworkSlug(network);
	return NETWORK_TOKEN_FALLBACK[slug] ?? slug;
}

export { formatNetworkLabel } from "../supported-networks";
